// extracted by mini-css-extract-plugin
module.exports = {"ds-image":"Image_ds-image__yVakF","ds-image-grid":"Image_ds-image-grid__lLvyp"};